import React from 'react'
import PropTypes from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'

export const SuggestionsSection = ({
  loading = false,
  hasResults = false,
  hasSuggestions = false,
  emptyTitle = 'No operations found for your search',
  emptySubtitle = 'No operations available right now. Please check back soon or try a different search.',
  suggestionsTitle = 'You might also be interested in',
  suggestionsSubtitle,
  children,
}) => {
  if (loading || hasResults) return null

  const showEmptyOnly = !hasSuggestions
  const showSuggestions = hasSuggestions

  return (
    <Stack spacing={2} sx={{ mt: 2 }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant='h6' gutterBottom>
          {emptyTitle}
        </Typography>
        {showEmptyOnly && (
          <Typography variant='body2' color='text.secondary'>
            {emptySubtitle}
          </Typography>
        )}
      </Box>

      {showSuggestions && (
        <Stack spacing={2}>
          <Box>
            <Typography variant='subtitle1' fontWeight={600}>
              {suggestionsTitle}
            </Typography>
            {suggestionsSubtitle ? (
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ mt: 0.5 }}
              >
                {suggestionsSubtitle}
              </Typography>
            ) : null}
          </Box>
          {children}
        </Stack>
      )}
    </Stack>
  )
}

SuggestionsSection.propTypes = {
  loading: PropTypes.bool,
  hasResults: PropTypes.bool,
  hasSuggestions: PropTypes.bool,
  emptyTitle: PropTypes.string,
  emptySubtitle: PropTypes.string,
  suggestionsTitle: PropTypes.string,
  suggestionsSubtitle: PropTypes.string,
  children: PropTypes.node,
}
